module.exports = __webpack_public_path__ + "media/functional__tony-2.1c2d18e1.webm";